import { AppShell } from '@mantine/core'
import { PageProps } from 'gatsby'
import { FC } from 'react'
import * as classes from './oneTimeLinkLayout.module.css'

const OneTimeLinkLayout: FC<PageProps> = ({ children }) => {
  return (
    <AppShell className={classes.container}>
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  )
}

export default OneTimeLinkLayout
